import { ACTION_TO_COMMAND } from "waapi/front-utils/commands/index.js";
import { ChromeMessage } from "../utils/extension/types.js";
import { useCloudRoutingDeps } from "../zustand/cloudRoutingDeps.js";
import { TryRouteToCloudResult } from "./types.js";

export const tryRouteToCloud = async (message: ChromeMessage): Promise<TryRouteToCloudResult> => {
    const { action, ...payload } = message;
    const command = ACTION_TO_COMMAND[action];
    const { akatsukiClient } = useCloudRoutingDeps.getState();
    if (!command || !akatsukiClient) return { routed: false };

    const response = await akatsukiClient.runCommand({
        body: { name: command.commandName, payload: command.buildPayload?.(payload) ?? payload },
    });

    if (response.hasFailed || !("data" in response)) return { routed: true, result: undefined };
    return { routed: true, result: command.transformResponse?.(response.data) ?? response.data };
};
